import { render, staticRenderFns } from "./IconDropUp.vue?vue&type=template&id=77f1630e&"
import script from "./IconDropUp.vue?vue&type=script&lang=ts&"
export * from "./IconDropUp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports